// @ts-check
/* eslint-disable @typescript-eslint/no-this-alias */

/**
 * @constructor
 */
export default function Action() {
  const self = this;

  self.type = 'button'; // disabled, button, hide
  self.label = 'button';
  self.css = 'btn btn-default';
  self.method = function (dialog) {};
}
